import EngineShell, { type SubTabDef } from '../components/EngineShell';
import ProfitAtRiskConsole from '../components/sims/ProfitAtRiskConsole';
import PricingMixConsole from '../components/sims/PricingMixConsole';
import SectorShockConsole from '../components/sims/SectorShockConsole';
import PreMortemConsole from '../components/sims/PreMortemConsole';
import WarGame from './WarGame';

/**
 * Engine 6 · Simulation (non-sequential). Runs across the value-chain spine.
 * Five live simulations, all reusing the V5 algorithm consoles. Drift Packet
 * and Spine-Anchored Scoring are NOT here — they live in Foundation.
 */
export default function Engine6Shell() {
  const subTabs: SubTabDef[] = [
    { id: 'wargame', name: 'War Game · Adversarial Twins', tier: 'lighthouse', moat: 'core', enabled: true, render: () => <WarGame /> },
    { id: 'profit-at-risk', name: 'Profit-at-Risk Monte Carlo', tier: 'lighthouse', moat: 'core', enabled: true, render: () => <ProfitAtRiskConsole /> },
    { id: 'pricing-mix', name: 'Pricing & Mix Sim', tier: 'flagship', moat: 'core', enabled: true, render: () => <PricingMixConsole /> },
    { id: 'sector-shock', name: 'Sector Concentration Shock', tier: 'flagship', moat: 'core', enabled: true, render: () => <SectorShockConsole /> },
    { id: 'pre-mortem', name: 'Pre-Mortem', tier: 'flagship', moat: 'core', enabled: true, render: () => <PreMortemConsole /> },
  ];

  return (
    <EngineShell
      engineId={6}
      engineName="Engine 6 · Simulation"
      engineCode="E6"
      subTabs={subTabs}
      backgrounds={[
        { id: 'twin-watch', name: 'Twin behavior watcher', status: 'ok' },
        { id: 'red-team', name: 'Red-team queue', status: 'ok' },
      ]}
    />
  );
}
